export const RoutePaths = {
    AUTHORIZATION: '/authorization',
    ORDERS: '/orders',
    MENU: '/menu',
    RESTAURANT: '/restaurant-page',
    LOGIN: '/login',
    POSITIONS: '/positions'
} as const;